import max from 'lodash/max'
import min from 'lodash/min'
import { useMemo } from 'react'
import type { CandleStickMinMaxData } from './typings'

const safeMax = (collection: number[] | null | undefined) => {
  return max(collection) || 0
}

const safeMin = (collection: number[] | null | undefined) => {
  return min(collection) || 0
}

export const useGetMinMaxDataValues = (data: CandleStickMinMaxData[]) => {
  const minMax = useMemo(() => {
    if (data.length >= 2) {
      const dataArray1 = data[0].data
      const dataArray2 = data[1].data

      const minMaxDataValues1 = {
        maxXDataValue: safeMax(dataArray1.map((point) => point.x)),
        minXDataValue: safeMin(dataArray1.map((point) => point.x)),
        maxYDataValue: safeMax(dataArray1.map((point) => point.high)),
        minYDataValue: safeMin(dataArray1.map((point) => point.low)),
      }

      const minMaxDataValues2 = {
        maxXDataValue: safeMax(dataArray2.map((point) => point.x)),
        minXDataValue: safeMin(dataArray2.map((point) => point.x)),
        maxYDataValue: safeMax(dataArray2.map((point) => point.high)),
        minYDataValue: safeMin(dataArray2.map((point) => point.low)),
      }

      return {
        maxXDataValue: safeMax([
          minMaxDataValues1.maxXDataValue,
          minMaxDataValues2.maxXDataValue,
        ]) as number,
        minXDataValue: safeMin([
          minMaxDataValues1.minXDataValue,
          minMaxDataValues2.minXDataValue,
        ]) as number,
        maxYDataValue: safeMax([
          minMaxDataValues1.maxYDataValue,
          minMaxDataValues2.maxYDataValue,
        ]) as number,
        minYDataValue: safeMin([
          minMaxDataValues1.minYDataValue,
          minMaxDataValues2.minYDataValue,
        ]) as number,
      }
    } else if (data.length === 1) {
      const dataArray = data[0].data
      return {
        minXDataValue: safeMin(dataArray.map((point) => point.x)) as number,
        maxXDataValue: safeMax(dataArray.map((point) => point.x)) as number,
        maxYDataValue: safeMax(dataArray.map((point) => point.high)) as number,
        minYDataValue: safeMin(dataArray.map((point) => point.low)) as number,
      }
    }
    return {
      minXDataValue: 0,
      maxXDataValue: 0,
      maxYDataValue: 0,
      minYDataValue: 0,
    }
  }, [data])
  return minMax
}
